module.exports = __webpack_public_path__ + "assets/panels/powermaster-33E-94abbcb9e601b07af34a9e8b8fbf4013.svg";